import { Injectable } from '@angular/core';
import { AbstractCRUD, ExceptionService, UtilsService } from '../../xform-compat';
import { BaseCRMItem } from '../../shared/models/crm/CRMItem.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BaseCrmService extends AbstractCRUD<BaseCRMItem> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/crm/base';
  }

  public emailLeader(itemId: number, subject: string, body: string): Observable<any> {
    const params = new HttpParams()
      .set('subject', subject)
      .set('body', body);
    return super.getHTTP().post(`${this.getApiPath()}/${itemId}/emailLeader`, {}, { params: params })
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
